import { useMutation } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { NonMemberJSON } from '../types';

type Params = {
	workspaceID: number;
	onSuccess: () => void;
	onError: () => void;
};

const useRequestSeatForNonMemberMutation = ( { workspaceID, onSuccess, onError }: Params ) => {
	const system = useWorkspaceSystem();

	return useMutation(
		( nonMember: NonMemberJSON ) => system.requestSeatForNonMember( {
			workspaceID, nonMemberID: nonMember.id
		} ),
		{ onSuccess, onError }
	);
};

export default useRequestSeatForNonMemberMutation;
